import { axios } from "utils";

export const getMe = (payload) =>
  axios.get(`/users/getMe`).then((res) => res.data?.doc);

export const updateMe = (payload) =>
  axios.patch("/users/updateMe", payload).then((res) => res.data?.doc);
